export const renderImage = (url, width, height) => {
  if (!url.startsWith("https://res.cloudinary.com/")) return url
  const userUrlArray = url.split('/upload/')
  if (userUrlArray[1].includes('c_crop')) {
    const transforms = userUrlArray[1].split('/v')
    return `${userUrlArray[0]}/upload/${transforms[0]}/c_fill,w_${width}${height ? `,h_${height}` : ''},c_limit/v${transforms[1]}`
  }
  return `${userUrlArray[0]}/upload/c_fill,w_${width}${height ? `,h_${height}` : ''},c_limit/${userUrlArray[1]}`
}